import actionTypes from '../constants/action-types';

const globals = (state = [], action) => {
  if (action.type !== actionTypes.SET_GLOBALS) return state;
  return action.payload.globals;
};

export default globals;
